<template>
    <div class="columns diagrams">
        <div class="column is-3">
            <b-field>
                <app-filter v-model="filter.application_id" expanded placeholder="Select App" @input="appSelect('filter')" @singleApp="isAppSingle = true">
                </app-filter>
            </b-field>
            <b-field v-if="domainOptionsFilter.length>1">
                <b-select v-model="filter.tag_id" placeholder="Select Domain" expanded>
                    <option :value="domain.id" v-for="domain in domainOptionsFilter" :key="domain.id">{{domain.attributes.value}}</option>
                </b-select>
            </b-field>
            <b-field v-show="domainOptionsFilter.length>1 || !isAppSingle">
                <b-button expanded @click="getDiagrams" :disabled="!(filter.application_id && filter.tag_id)" ref="diagram_search">Search</b-button>
            </b-field>
            <div class="panel">
                <b-table :data="diagrams" class="panel-block" :loading="tableloading">
                    <template slot-scope="props">
                        <b-table-column :class="model === props.row.id ? 'topic active' :''">
                            <a href="#" @click="setModel(props.row)" class="topic">
                                {{props.row.attributes.name}}
                            </a>
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="column is-9">
            <div>
                <span class="title" id="diagram-name" v-if="!isRole('superadmin')">
                    {{data.name}}
                </span>
                <b-field v-else class="level m-b-sm">
                    <b-field class="level-item level-left">
                        <b-input v-model="data.name" placeholder="Enter Name" expanded></b-input>
                    </b-field>
                    <span class="is-pulled-right cursor-pointer is-size-5 level-item level-right" v-if="Object.keys(this.model).length" @click="removeModel">
                        <b-icon icon="close"></b-icon>
                    </span>
                </b-field>
            </div>
            <div class="columns" v-if="isRole('superadmin')">
                <app-filter v-model="data.application_id" placeholder="Select App" class="column" :preSelect="null" @input="appSelect('field')"/>
                <b-select v-model="data.tag_id" placeholder="Select Domain" class="column" expanded>
                    <option :value="domain.id" v-for="domain in domainOptionsField" :key="domain.id">{{domain.attributes.value}}</option>
                </b-select>
                <b-field class="column">
                    <b-button expanded :disabled="!isValid" @click="save">Save</b-button>
                </b-field>
            </div>
            <div class="zoom-container">
                <b-button icon-left="magnify-plus-outline" @click="updateZoom('add')" class="m-r-xs"/>
                <b-button icon-left="magnify-minus-outline" @click="updateZoom('minus')"/>
            </div>
            <div class="box" style="overflow: auto; height: 52vh;">
                <section id="graph" :style="chartStyle">
                    <div id="graphDiv">
                        {{ data.data }}
                    </div>
                </section>
            </div>
            <div class="box">
                <b-input type="textarea" placeholder="Code" row.native="50" v-model="data.data">
                </b-input>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable */
import Vue from 'vue';
import AppFilter from '../../../../../components/AppFilter.vue'
import mermaid from "mermaid";
export default {
    components:{
        AppFilter,
    },
    data() {
        return {
            domainOptionsFilter:[],
            options:{
                markdownIt: {
                    linkify: true
                },
                linkAttributes: {
                    attrs: {
                        target: '_blank',
                        rel: 'noopener'
                    }
                }
            },
            data:{
                application_id:null,
                data:null,
                tag_id: null,
                name:'Diagram Title',
            },
            output:null,
            timeout:null,
            model:{},
            filter:{
                tag_id:null,
                application_id:null
            },
            diagrams:[],
            isAppSingle: false,
            tableloading: false,
            domainOptionsField: [],
            zoomNum: 50
        }
    },
    watch:{
        'data.data'(newValue){
            this.generate(newValue)
        },
        filter:{
            deep:true,
            handler(newValue){
                localStorage['diagramFilters'] = JSON.stringify(newValue)
            }
        }
    },
    computed: {
        isValid(){
            return this.data.name && this.data.application_id && this.data.tag_id && this.data.data
        },
		chartStyle() {
			return {
				zoom: this.zoomNum + '%'
			}
		},
    },
    methods:{
        appSelect(type){
            if(type==='filter' && this.filter.application_id){
                this.filter.tag_id = null
                this.getTags(type,this.filter.application_id)
            }else if(type==='field' && this.data.application_id){
                this.data.tag_id = null
                this.getTags(type,this.data.application_id)
            }
        },
        getTags(type,app_id) {
            let data = {app_id:app_id}
            let payload = Object.keys(data).map(key=>`${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`).join('&')
            Vue.$tagService.getList(`?${payload}`).then((response)=>{
                if(type==='filter'){
                    this.domainOptionsFilter = response.data
                    if(this.domainOptionsFilter.length==1){
                        this.filter.tag_id = this.domainOptionsFilter[0].id
                        this.$refs.diagram_search.$el.click()
                    }
                }else{
                    this.domainOptionsField = response.data
                    if(this.domainOptionsField.length==1){
                        this.filter.tag_id = this.domainOptionsField[0].id
                    }
                }
            })
        },
        // encode64(data){
        //     var r = "";
        //     for (var i=0; i<data.length; i+=3) {
        //         if (i+2==data.length) {
        //             r +=this.append3bytes(data.charCodeAt(i), data.charCodeAt(i+1), 0);
        //         } else if (i+1==data.length) {
        //             r += this.append3bytes(data.charCodeAt(i), 0, 0);
        //         } else {
        //             r += this.append3bytes(data.charCodeAt(i), data.charCodeAt(i+1),
        //             data.charCodeAt(i+2));
        //         }
        //     }
        //     return r;
        // },
        // append3bytes(b1, b2, b3) {
        //     var c1 = b1 >> 2;
        //     var c2 = ((b1 & 0x3) << 4) | (b2 >> 4);
        //     var c3 = ((b2 & 0xF) << 2) | (b3 >> 6);
        //     var c4 = b3 & 0x3F;
        //     var r = "";
        //     r += this.encode6bit(c1 & 0x3F);
        //     r += this.encode6bit(c2 & 0x3F);
        //     r += this.encode6bit(c3 & 0x3F);
        //     r += this.encode6bit(c4 & 0x3F);
        //     return r;
        // },
        // encode6bit(b) {
        //     if (b < 10) {
        //         return String.fromCharCode(48 + b);
        //     }
        //     b -= 10;
        //     if (b < 26) {
        //         return String.fromCharCode(65 + b);
        //     }
        //     b -= 26;
        //     if (b < 26) {
        //         return String.fromCharCode(97 + b);
        //     }
        //     b -= 26;
        //     if (b == 0) {
        //         return '-';
        //     }
        //     if (b == 1) {
        //         return '_';
        //     }
        //         return '?';
        // },
        generate(val){
            if(!val){
                val = ''
            }
            clearTimeout(this.timeout)
            this.timeout = setTimeout(()=>{
                // var s = unescape(encodeURIComponent(this.data.data));
                // this.output = "https://www.plantuml.com/plantuml/png/"+this.encode64(deflate(s, 9));

                var element = document.querySelector("#graphDiv");
                var insertSvg = function(svgCode, bindFunctions){
                    element.innerHTML = svgCode;
                };
                var graph = mermaid.render('graphDiv', val, insertSvg);
                var element = document.getElementById('graph');
                element.innerHTML = graph;
            },1000)
        },
        async save() {
            if(Object.keys(this.model).length){
                await this.updateDiagram().then((response)=>{
                    this.model = response.data
                    this.filter = {
                        application_id: this.data.application_id,
                        tag_id: this.data.tag_id
                    }
                })
            }else{
                await this.createDiagram().then((response)=>{
                    this.model = response.data
                    this.filter = {
                        application_id: this.data.application_id,
                        tag_id: this.data.tag_id
                    }
                })
            }
            this.getDiagrams()
            this.$buefy.toast.open({
                type: 'is-success',
                message: 'Diagram saved!'
            })
        },
        createDiagram() {
            return Vue.$diagramService.createDiagram(this.data)
        },
        updateDiagram(){
            return Vue.$diagramService.updateDiagram(this.model.id,this.data)
        },
        getDiagrams() {
            this.tableloading = true    
            let payload = Object.keys(this.filter).map(key=>`${encodeURIComponent(key)}=${encodeURIComponent(this.filter[key])}`).join('&')
            Vue.$diagramService.diagramList(`?${payload}`).then((response)=>{
                this.tableloading = false
                this.diagrams = response.data
            })
        },
        setModel(diagram){
            this.model = diagram
            this.data.data = diagram.attributes.data
            this.data.name = diagram.attributes.name
            this.data.application_id = diagram.attributes.application_id
            this.data.tag_id = diagram.attributes.tag_id
            this.getTags('field',this.data.application_id)
        },
        removeModel(){
            this.model = {}
            this.data.data = null
            this.data.name = 'Diagram Title'
            this.data.application_id = null
            this.data.tag_id = null
        },
        getFilters() {

            var filters = JSON.parse(localStorage.getItem('diagramFilters'))
            if(filters){
                this.filter = filters
                this.appSelect('filter',this.filter.application_id)
            }
        },
        updateZoom(type){
            switch(type){
                case 'add':
                    this.zoomNum+=10;
                    break;
                case 'minus':
                    this.zoomNum-=10;
                    break;
            }
        }
    },
    mounted() {
        this.getFilters()
    	mermaid.initialize({
	        startOnLoad:false
	    });
    }

}
</script>
<style lang="scss">
#graph{
    width: max-content;
}

.zoom-container {
    position: absolute;
    right: 1vw;
    padding: 1rem;
}
</style>